<template>
    <div class="consul-deal clearfix" style="position:relative;">
        <div class="deal-content marginP " >
    <div class="consul-sheet-wrap deal-sheet-wrap" v-loading="!isSuccess">
        <div v-if="isSuccess">
            <ImageAmplify/>
            <div class="video-Top">
                <label class="searchTip" style="color:#92412B;">状态：{{consultDetail.consultStatusDescription}}</label>
            </div>
            <div class=" clearfix">
                    <div class="launch-title1" style="background: #F9F9F9;margin-top:10px;">
                        <p>基本信息</p>
                    </div>
                <div style="background: #fff;box-sizing: border-box;padding:0px 20px;" class="box-borders">
                    <div style="height:36px;box-sizing: border-box;line-height: 36px;">
                        <label class="fl order-num jet-black">NO.{{ consultDetail.consultGroup.consultGroupNo }}</label>
                        <label class="fr order-num jet-black">问诊费用：<span class="fee-num">￥{{ consultDetail.consultGroup.consultFee }}</span></label>
                    </div>
                    <div class="clearfix" style="height:36px;">
                        <span class="name patient-list-item jet-black lineH30 fontSize14">{{ consultDetail.consultGroup.consulterName }}</span>
                        <span class="patient-list-item lineH30 jet-gray">{{ consultDetail.consultGroup.consulterGender =="M"?"男":"女" }}</span>
                        <span class="patient-list-item lineH30 jet-gray">{{ consultDetail.consultGroup.consulterAge }}岁</span>
                        <span class="patient-list-item lineH30 jet-gray">患者病历号：{{consultDetail.consultGroup.consulterInhosno}}</span>
                    </div>
                    <div class="clearfix" style="height:36px;">
                        <span class="patient-list-item lineH30 jet-gray">电话：{{ consultDetail.consultGroup.consulterMobile }}</span>
                        <span class="patient-list-item lineH30 jet-gray">身份证：{{ consultDetail.consultGroup.consulterIdcard }}</span>
                        <span class="patient-list-item lineH30 jet-gray">职业：{{consultDetail.consultGroup.consulterJob?consultDetail.consultGroup.consulterJob:"无"}}</span>
                        <span class="patient-list-item lineH30 jet-gray">婚姻：{{maritalStatus}}</span>
                    </div>
                    <div class="clearfix" style="height:36px;">
                        <span class="patient-list-item lineH30 jet-gray">家庭住址：{{consultDetail.areaNameArr[0]}}</span>
                        <span class="patient-list-item lineH30 jet-gray">{{consultDetail.areaNameArr[1]}}</span>
                        <span class="patient-list-item lineH30 jet-gray">{{consultDetail.areaNameArr[2]}}</span>
                        <span class="patient-list-item lineH30 jet-gray">{{consultDetail.consultGroup.consulterAddress}}</span>
                    </div>
                </div>

                    <div class="launch-title1" style="background: #F9F9F9;margin-top:10px;">
                        <p>简要病史（申请医生填写）</p>
                    </div>
                    <div style="background: #fff;box-sizing: border-box;padding:10px 20px;" class="box-borders">
                        <div class="lineH22 marginB10">
                            <span class="jet-gray">患者主诉：</span>
                            <div class="linecon" style="margin-left:7%;">
                                {{ consultDetail.consultGroup.consultContent }}
                            </div>
                        </div>
                        <div class="lineH22 marginB10">
                            <span class="jet-gray">初步诊断：</span>
                            <div class="linecon" style="margin-left:7%;">
                                {{ consultDetail.consultGroup.beforeDiagnose }}
                            </div>
                        </div>
                        <div class="lineH22 marginB10">
                            <span class="jet-gray">会诊目的：</span>
                            <div class="linecon" style="margin-left:7%;">
                                {{ consultDetail.consultGroup.consultReason }}
                            </div>
                        </div>
                        <div class="add-pic-list ghost-btn-wrap" style="align-items:flex-start;">
                            <span class="jet-gray">病历资料：</span>
                                <!--<el-button-->
                                        <!--size="small"-->
                                        <!--type="ghost"-->
                                        <!--style="margin-left:15px;"-->
                                        <!--@click="linkToCx"-->
                                        <!--class="ghost-btn">电子病历</el-button>-->
                        </div>
                        <div style="margin-left:70px;margin-top:10px;">
                            <img v-for="(item,index) in imgList" class="item-pic w88 h88 marginR10" :src="item.attaFileUrl" :key="index" @click="handleImageAmplify(index, imgList, $event)" style="margin-left:10px;">
                        </div>
                        <ul class="el-upload-list el-upload-list--text" style="margin-left:70px;">
                            <li class="el-upload-list__item is-success" v-for="(item, index) in fileList" :key="index">
                                <a class="el-upload-list__item-name" :href="item.attaFileUrl" target="_blank">
                                    <i class="el-icon-document"></i>
                                    {{ item.attaFileName }}
                                </a>
                            </li>
                        </ul>
                        <div>
                            <div class="ghost-btn-wrap marginT10">
                                <el-button size="mini" class="ghost-btn" @click="showPerfectLisRecord">{{ isShowPerfectList?'隐藏补充资料记录':'显示补充资料记录' }}</el-button>
                            </div>
                            <ul v-if="isShowPerfectList">
                                <li class="marginT10" v-for="(item, index) in perfectList">
                                    <span class="jet-gray">{{ item.perfectContent }}</span>
                                    <span class="marginL20 jet-gray">{{ item.createTime ? formatUnix(item.createTime, 'MM-dd HH:mm') : '' }}</span>
                                </li>
                            </ul>
                        </div>
                    </div>
                    <div class="paddingB10">
                        <div class="blue-btn-wrap clearfix">

                        </div>
                    </div>
                <div class="launch-title1" style="background: #F9F9F9;">
                    <p>会诊申请信息</p>
                </div>

                <div style="background: #fff;box-sizing: border-box;padding:10px 20px;" class="box-borders">
                    <div class="lineH22 marginB10 Allnews">
                        <span class="jet-gray">申请类型：<span style="color:#000000;">{{ consultDetail.consultGroup.consultGroupType }}</span></span>
                        <span class="jet-gray " style="position:absolute;left:200px;" >辅助诊断类型：<span style="color:#000000;">{{ consultDetail.consultGroup.auxiliaryDiagnose }}</span></span>
                    </div>
                    <div class=" marginB10 paddingT10 Allnews">
                        <span class="jet-gray">期望会诊医院：<span style="color:#000000;">{{ consultDetail.consultGroup.hopeHosName?consultDetail.consultGroup.hopeHosName:consultDetail.consultGroup.acceptHosName }}</span></span>
                        <span class="jet-gray" style="position:absolute;left:300px;" >期望会诊科室：<span style="color:#000000;">{{ consultDetail.consultGroup.hopeDeptName?consultDetail.consultGroup.hopeDeptName:consultDetail.consultGroup.acceptDeptName }}</span></span>
                        <span class="jet-gray" style="position:absolute;left:480px;" >期望会诊医生：<span style="color:#000000;">{{ consultDetail.consultGroup.hopeDocName?consultDetail.consultGroup.hopeDocName:consultDetail.consultGroup.acceptDocName }}</span></span>
                        <span class="jet-gray marginL20" style="position:absolute;left:650px;">邀请会诊时间：<span style="color:#000000;">{{consultDetail.consultGroup.hopeTime?consultDetail.consultGroup.hopeTime:'无'}}</span></span>
                    </div>
                    <div class=" marginB10 paddingT10 Allnews">
                        <span class="jet-gray">申请医院：<span style="color:#000000;" >{{ consultDetail.consultGroup.initHosName}}</span></span>
                        <span class="jet-gray" style="position:absolute;left:300px;" >申请科室：<span style="color:#000000;">{{ consultDetail.consultGroup.initDeptName}}</span></span>
                        <span class="jet-gray" style="position:absolute;left:480px;">申请医生：<span style="color:#000000;">{{ consultDetail.consultGroup.initDocName}}</span></span>
                        <span class="jet-gray marginL20" style="position:absolute;left:650px;">申请时间：<span style="color:#000000;">{{ formatUnix(consultDetail.consultGroup.createTime) }}</span></span>
                    </div>
                </div>

                <div v-if="!isShowVideo" style="margin-top:10px;">
                    <div class="consul-form-item">
                        <div class="launch-title1" style="background: #F9F9F9;">
                            <p>资料审核<span :class="[consultDetail.consultGroup.readyStatus?'':'fee-num']">（资料未就绪状态不能开启会诊）</span></p>
                        </div>
                        <div style="background: #fff;box-sizing: border-box;padding:10px 0px 20px 0px;" class="box-borders">
                            <div style="overflow: hidden;height:60px;">
                                <div class="showcheck-hs1" :class="{ 'aa': clickname=='1','cc':clickname!='1'}" @click="jcbg"><span>资料已就绪</span>
                                    <svg class="icon fontSize16" aria-hidden="true" v-show="show4">
                                        <use xlink:href="#icon-duihao"></use>
                                    </svg>
                                </div>
                                <div class="showcheck-hs1" :class="{ 'aa': clickname=='2','cc':clickname!='2'}" @click="jybg">
                                    <span>资料缺失</span>
                                    <svg class="icon fontSize16" aria-hidden="true" v-show="show5">
                                        <use xlink:href="#icon-duihao"></use>
                                    </svg>
                                </div>
                            </div>
                            <div style="margin-top:20px;" v-show="shows10">
                                <el-input :disabled="dataReady==1" v-model="remark"class="data-input w500 h30 marginL20" placeholder="例如：请补充X光片、检验报告等"/>
                            </div>
                        </div>
                        <!--:disabled="isArrangeTime"-->
                    </div>
                    <div class="consul-form-item ">
                        <div class="ghost-btn-wrap clearfix ">
                            <div class="launch-title1" style="background: #F9F9F9;margin-top:10px;position:relative;">
                                <p>安排会诊</p>
                                <!--<el-button class="ghost-btn invite-btn fr" @click="inviteVideo" size="small" style="position:absolute;right:20px;top:1px;">邀请医生</el-button>-->
                            </div>
                        </div>
                        <div style="background: #fff;box-sizing: border-box;padding:10px 0px;" class="box-borders">
                            <div style="overflow: hidden;height:60px;">
                                <div class="showcheck-hs1" :class="{ 'aa': clickname1=='3','cc':clickname1!='3'}" @click="jcbg1"><span>安排会诊</span>
                                    <svg class="icon fontSize16" aria-hidden="true" v-show="show6">
                                        <use xlink:href="#icon-duihao"></use>
                                    </svg>
                                </div>
                                <div class="showcheck-hs1"  v-if="!isArrangeTime" :class="{ 'aa': clickname1=='4','cc':clickname1!='4'}" @click="jybg1">
                                    <span>拒绝会诊</span>
                                    <svg class="icon fontSize16" aria-hidden="true" v-show="show7">
                                        <use xlink:href="#icon-duihao"></use>
                                    </svg>
                                </div>
                            </div>
                            <div v-show="shows8" style="margin-top:20px;">
                                <label class="marginL20">会诊医生</label>
                                <el-select
                                        v-model="acceptHosId"
                                        size="small"
                                        class="w165 h36"
                                        filterable
                                        :loading="loading"
                                        placeholder="请选择医院">
                                    <!--:disabled="isArrangeTime||isArrangeSelect"-->
                                    <el-option v-for="item in hosList" :label="item.hosName" :value="item.id" :key="item.id"/>
                                </el-select>
                                <el-select
                                        v-model="acceptDeptId"
                                        size="small"
                                        class="w165 h36"
                                        filterable
                                        @change="getDeptId"
                                        :loading="loading"
                                        placeholder="请选择科室">
                                    <!--:disabled="isArrangeTime||isArrangeSelect"-->
                                    <el-option v-for="item in deptList" :label="item.deptName" :value="item.id" :key="item.id"/>
                                </el-select>
                                <el-select
                                        v-model="acceptDocId"
                                        size="small"
                                        class="w112 h36"
                                        filterable
                                        @change="getDocId"
                                        :loading="loading"
                                        placeholder="请选择医生">
                                    <!--:disabled="isArrangeTime||isArrangeSelect"-->
                                    <el-option v-for="item in docList" :label="item.docName" :value="item.id" :key="item.id"/>
                                </el-select>
                                <div class=" marginT10" style="margin-left:20px;">
                                    <label >会诊时间</label>
                                    <el-date-picker
                                            v-model="selectDate"
                                            size="small"
                                            class="w160"
                                            :editable="false"
                                            type="datetime"
                                            format="yyyy-MM-dd HH:mm"
                                            placeholder="选择时间">
                                    </el-date-picker>
                                    <!--:disabled="isArrangeTime||isArrangeSelect"-->
                                </div>
                            </div>
                            <div v-show="shows9" style="margin-top:20px;">
                                <el-input v-if="!isArrangeTime" class="data-input w500 reject-content-input marginL20" v-model="rejectContent" :disabled="!isArrangeSelect" placeholder="请输入拒绝理由"/>
                                <div class="blue-btn-wrap inlineBlock">
                                    <el-button v-if="isArrangeSelect" type="primary" class="blue-btn marginL10" @click="rejectConsul" :loading="isReject">拒绝</el-button>
                                </div>
                            </div>
                        </div>
                        <!--:disabled="isArrangeTime"-->
                        <!--<div class="sheet-content">-->
                            <!--<div v-for="(item, index) in inviteVoList" :key="index" class="marginL25">-->
                                <!--<label class="jet-gray">邀请医生</label>-->
                                <!--<span>{{ item.hosName+' - '+item.deptName+' - '+item.userName }}</span>-->
                            <!--</div>-->
                        <!--</div>-->
                    </div>
                    <div class="launch-title1"  v-show="showsY" style="background: #F9F9F9;margin-top:10px;">
                        <p>会诊情况记录</p>
                    </div>
                    <div style="background: #fff;box-sizing: border-box;padding:20px 20px;" v-show="showsY" class=" sheet-content box-borders">
                        <div class="clearfix  evaluate-launch-wrap" style="height:36px;">
                            <label><span class="fee-num"></span>患者病情情况：</label>
                            <el-select v-model="consulterDiagnoseLevel " size="small" style="width:100px;" class="w60 h24 launch-input">
                                <el-option label="一般" value="0"/>
                                <el-option label="严重" value="1"/>
                            </el-select>
                            <label><span class="fee-num"></span>是否建议转诊：</label>
                            <el-select v-model="transFer" size="small" style="width:100px;" class="w60 h24 launch-input" :disabled="transFer2">
                                <el-option label="是" value="0"/>
                                <el-option label="否" value="1"/>
                            </el-select>
                            <el-button
                                    size="small"
                                    type="ghost"
                                    v-if="transFer=='0'"
                                    @click="getHosTransfer1"
                                    class="ghost-btn">门诊转诊
                            </el-button>
                            <el-button
                                    size="small"
                                    type="ghost"
                                    v-if="transFer=='0'"
                                    @click="getHosTransfer"
                                    class="ghost-btn">急诊转诊
                            </el-button>
                            <el-button
                                    size="small"
                                    type="ghost"
                                    v-if="transFer=='0'"
                                    @click="getHosTransfer2"
                                    class="ghost-btn">住院转诊
                            </el-button>
                        </div>
                        <div class="clearfix" style="height:36px;">
                            <label><span class="fee-num"></span>患者转诊情况：</label>
                            <span class="label-content ">{{zzqk}}</span>
                        </div>
                    </div>
                    <div class="consul-form-item marginB30 h30 consult-content-wrap bgc-white ">
                        <div class="fr">
                            <label class="light-gray">处理时间：</label>
                            <span class="label-content light-gray">{{ consultDetail.consultGroup.modifyTime?formatUnix(consultDetail.consultGroup.modifyTime):'' }}</span>
                            <label class="light-gray">处理人：</label>
                            <span class="label-content light-gray">{{ consultDetail.consultGroup.initHosName+' - '+consultDetail.consultGroup.initDeptName+' - '+consultDetail.consultGroup.initDocName}}</span>
                        </div>
                    </div>
                    <div class="submit-btn-wrap blue-btn-wrap marginB20">
                        <div style="width:60%;margin-left:20%;text-align: center;">
                            <el-popover
                                    ref="popoverConfirm"
                                    placement="top"
                                    v-if="!isShowVideo"
                                    width="166">
                                <div class="ghost-btn-wrap w180">
                                    <el-dropdown @command="linkEnterHD">
                                        <el-button type="ghost" size="small" class="ghost-btn w80">
                                            高清视频<i class="el-icon-caret-bottom el-icon&#45;&#45;right"></i>
                                        </el-button>
                                        <el-dropdown-menu slot="dropdown">
                                            <el-dropdown-item class="fontSize12 h30" command="560222@cucmp1.onecc.me">DX70</el-dropdown-item>
                                            <el-dropdown-item class="fontSize12 h30" command="560020@onecc.me">DX80</el-dropdown-item>
                                            <el-dropdown-item class="fontSize12 h30" command="55002@onecc.me">IS5000</el-dropdown-item>
                                            <!--<el-dropdown-item class="fontSize12 h30" command="560035@cucmp1.onecc.me">DX80</el-dropdown-item>
                                            <el-dropdown-item class="fontSize12 h30" command="cs1@onecc.me">SX20</el-dropdown-item>-->
                                        </el-dropdown-menu>
                                    </el-dropdown>
                                    <el-button type="ghost" size="small" class="ghost-btn w80" @click="linkToEnter">电脑</el-button>
                                </div>
                            </el-popover>
                            <el-button
                                    v-if="isArrangeTime"
                                    v-show="showscci"
                                    type="primary"
                                    class="blue-btn  h36 w140"
                                    v-popover:popoverConfirm>进入诊间
                            </el-button>
                            <el-button
                                    v-if="isArrangeTime"
                                    type="primary"
                                    @click="linkToEnterHushi"
                                    :loading="showVideos"
                                    class="blue-btn  h36 w140"
                                    >进入诊间
                            </el-button>
                            <el-button
                                    v-if="isArrangeTime"
                                    v-show="shows11"
                                    type="primary"
                                    :disabled="showsVideo"
                                    class="blue-btn  h36 w140"
                                    @click="linkToCancel">取消会诊
                            </el-button>
                            <el-button
                                    v-if="!isArrangeSelect&&identity=='ASS'"
                                    type="primary"
                                    :loading="submits"
                                    class="blue-btn  h36 w140"
                                    @click="submitConsul">提交
                            </el-button>
                            <el-button
                                    v-if="isArrangeTime"
                                    type="primary"
                                    class="blue-btn  h36 w140"
                                    @click="linkToEnd">完成会诊
                            </el-button>
                        </div>
                    </div>
                </div>
                <div class="live-wrap" v-if="isShowVideo" >
                    <video v-if="isTest" ref="video" style="display:block; background-color:black; width:800px; height:418px; margin:0; padding:0;" :src="testSrc"></video>
                    <iframe v-else allowfullscreen :src="videoSrc" frameborder="0" style="display:block; background-color:black; width:800px; height:418px; margin:0; padding:0;" >
                    </iframe>
                    <div class="live-bottom h49 blue-btn-wrap clearfix">
                        <el-button v-if="!isTest" type="primary" class="blue-btn h24 w112 marginL10 fr" @click="linkToEnd">完成会诊</el-button>
                        <el-button type="primary" class="blue-btn h24 w112 fr" @click="linkToOut">{{ isTest?'退出测试':'临时退出' }}</el-button>
                    </div>
                </div>
            </div>
        </div>
        <AddDoctorMsgBox v-if="isShowAddDocBox" @hide="hiddenAddDocBox" type="remoteVideo" :consultId="consultId"/>
    </div>

            <!--急诊转诊提示-->
            <div class="ssts1 ghost-btn-wrap" v-show="showBox1">
                <div style="width:100%;height:65px;position:relative;">
                    <img class="imgposition" src="../../../images/transfer.png" alt="">
                </div>
                <div style="margin-top:20px;">
                    <p style="color:#333;text-align: center;font-weight: bold;">是否确定为该患者申请急诊转诊？</p>
                </div>
                <div style="margin-top:30px;width:70%;margin-left:15%;">
                    <p style="color:#8A8A8A;text-align: center;font-size: 14px;line-height:24px;">提示：对于异地转诊患者，如是初诊患者，系统会对其进行实名认证，通过后在线建档。</p>
                </div>
                <div style="margin-top:20px;">
                    <el-select
                            v-model="initHosId"
                            size="small"
                            style="margin-left:5px;"
                            class="launch-input w150 h24"
                            filterable
                            :loading="loading"
                            placeholder="请选择申请医院"
                            @change="getInitHospId">
                        <el-option v-for="item in hospListZ" :label="item.yymc" :value="item.yyid" :key="item.yyid"/>
                    </el-select>
                    <el-select
                            v-model="initDeptId"
                            size="small"
                            style="margin-left:5px;"
                            class="launch-input w150 h24"
                            filterable
                            @visible-change="getInitDeptList"
                            @change="getInitDeptId"
                            :loading="loading"
                            placeholder="请选择申请科室">
                        <el-option v-for="item in initDeptList" :label="item.ksmc" :value="item.ksid" :key="item.ksid"/>
                    </el-select>
                    <el-select
                            v-model="initDocId"
                            size="small"
                            style="margin-left:5px;"
                            class="launch-input w150 h24"
                            filterable
                            :loading="loading"
                            @visible-change="getInitDocList"
                            @change="getInitDocId"
                            placeholder="请选择申请医生">
                        <el-option v-for="item in initDocList" :label="item.ysxm" :value="item.ysid" :key="item.ysid"/>
                    </el-select>
                </div>
                <!--<div  style="margin-top:20px;width:70%;margin-left:15%;">-->
                    <!--<p @click="showjpg" style="cursor:pointer;color:#92412B;text-decoration:underline;text-align: center;font-size: 14px;line-height:24px;">急诊转诊:查看认证，建档流程.jpg</p>-->
                <!--</div>-->
                <div style="position:relative;margin-top:50px;">
                    <el-button
                            type="ghost"
                            style="position:absolute;width:150px;left:50px;top:0;"
                            @click="closeBox"
                            class="ghost-btn">返回
                    </el-button>
                    <el-button
                            type="primary"
                            class="submit-btn blue-btn h36 w200 "
                            @click="SureTransf"
                            style="position:absolute;right:50px;top:0;">
                        确定转诊，获取病案号
                    </el-button>
                </div>
            </div>
            <!--住院转诊提示-->
            <div class="ssts1 ghost-btn-wrap" v-show="showBox6">
                <div style="width:100%;height:65px;position:relative;">
                    <img class="imgposition" src="../../../images/transfer.png" alt="">
                </div>
                <div style="margin-top:20px;">
                    <p style="color:#333;text-align: center;font-weight: bold;">是否确定为该患者申请住院转诊？</p>
                </div>
                <div style="margin-top:30px;width:70%;margin-left:15%;">
                    <p style="color:#8A8A8A;text-align: center;font-size: 14px;line-height:24px;">提示：对于异地转诊患者，如是初诊患者，系统会对其进行实名认证，通过后在线建档。</p>
                </div>
                <div style="margin-top:20px;">
                    <el-select
                            v-model="initHosId"
                            size="small"
                            style="margin-left:5px;"
                            class="launch-input w150 h24"
                            filterable
                            :loading="loading"
                            placeholder="请选择申请医院"
                            @change="getInitHospId">
                        <el-option v-for="item in hospListZ" :label="item.yymc" :value="item.yyid" :key="item.yyid"/>
                    </el-select>
                    <el-select
                            v-model="initDeptId"
                            size="small"
                            style="margin-left:5px;"
                            class="launch-input w150 h24"
                            filterable
                            @visible-change="getInitDeptList"
                            @change="getInitDeptId"
                            :loading="loading"
                            placeholder="请选择申请科室">
                        <el-option v-for="item in initDeptList" :label="item.ksmc" :value="item.ksid" :key="item.ksid"/>
                    </el-select>
                    <el-select
                            v-model="initDocId"
                            size="small"
                            style="margin-left:5px;"
                            class="launch-input w150 h24"
                            filterable
                            :loading="loading"
                            @visible-change="getInitDocList"
                            @change="getInitDocId"
                            placeholder="请选择申请医生">
                        <el-option v-for="item in initDocList" :label="item.ysxm" :value="item.ysid" :key="item.ysid"/>
                    </el-select>
                </div>
                <!--<div  style="margin-top:20px;width:70%;margin-left:15%;">-->
                <!--<p @click="showjpg" style="cursor:pointer;color:#92412B;text-decoration:underline;text-align: center;font-size: 14px;line-height:24px;">住院转诊:查看认证，建档流程.jpg</p>-->
                <!--</div>-->
                <div style="position:relative;margin-top:50px;">
                    <el-button
                            type="ghost"
                            style="position:absolute;width:150px;left:50px;top:0;"
                            @click="closeBox"
                            class="ghost-btn">返回
                    </el-button>
                    <el-button
                            type="primary"
                            class="submit-btn blue-btn h36 w200 "
                            @click="SureTransf"
                            style="position:absolute;right:50px;top:0;">
                        确定转诊，获取病案号
                    </el-button>
                </div>
            </div>
            <!--急诊转诊成功-->
            <div class="ssts2 ghost-btn-wrap" v-show="showBox2">
                    <div style="background:#ccc;width:90px;height:90px;position:absolute;left:0;right:0;top:20px;margin: 0 auto;">
                        <img src="../../../images/success.png" alt="">
                    </div>
                    <div style="margin-top:130px;width:60%;margin-left:20%;">
                          <p style="text-align: center;">该患者建档成功</p>
                    </div>
                    <div style="margin-top:30px;width:50%;margin-left:25%;">
                          <p style="text-align: center;">该患者在本院的病案号为:</p>
                    </div>
                    <div style="margin-top:30px;width:50%;margin-left:25%;">
                        <p style="text-align: center;">{{bah}}</p>
                    </div>
                        <el-button
                                type="ghost"
                                style="position:absolute;width:150px;left:0;right:0;bottom:20px;margin:0 auto;"
                                @click="closeBox2"
                                class="ghost-btn">我知道了
                        </el-button>
            </div>
            <!--急诊转诊失败-->
             <div class="ssts4" v-show="showBox4">
                 <div style="background:#ccc;width:90px;height:90px;position:absolute;left:0;right:0;top:20px;margin: 0 auto;">
                     <img src="../../../images/error.png" alt="">
                 </div>
                 <div style="margin-top:100px;width:60%;margin-left:20%;">
                     <p style="text-align: center;">病案号获取失败</p>
                 </div>
                 <div style="margin-top:30px;width:70%;margin-left:15%;">
                     <p style="text-align: center;">{{bahms}}</p>
                 </div>
                 <el-button
                         type="ghost"
                         style="position:absolute;width:150px;left:0;right:0;bottom:20px;margin:0 auto;"
                         @click="closeBox4"
                         class="ghost-btn">我知道了
                 </el-button>
             </div>
            <!--急诊转诊已有病案号-->
            <div class="ssts2 ghost-btn-wrap" v-show="showBox5">
                <div style="background:#ccc;width:90px;height:90px;position:absolute;left:0;right:0;top:20px;margin: 0 auto;">
                    <img src="../../../images/success.png" alt="">
                </div>
                <div style="margin-top:100px;width:60%;margin-left:20%;">
                    <p style="text-align: center;">该患者在该院已有病案号</p>
                </div>
                <div style="margin-top:30px;width:50%;margin-left:25%;">
                    <p style="text-align: center;">该患者在本院的病案号为:</p>
                </div>
                <div style="margin-top:30px;width:50%;margin-left:25%;">
                    <p style="text-align: center;">{{bah}}</p>
                </div>
                <el-button
                        type="ghost"
                        style="position:absolute;width:150px;left:0;right:0;bottom:20px;margin:0 auto;"
                        @click="closeBox5"
                        class="ghost-btn">我知道了
                </el-button>
            </div>
            <!--住院转诊流程图提示-->
            <div class="ssts3 ghost-btn-wrap" v-show="showBox3" >
                <img src="../../../images/arranges.png" alt="" style="width:100%;height:90%;">
                <el-button
                        type="ghost"
                        style="position:absolute;width:150px;left:0;right:0;bottom:20px;margin:0 auto;"
                        @click="closeBox3"
                        class="ghost-btn">返回
                </el-button>
            </div>
            <!--门诊转诊提示-->
              <!--<div class="ssts1 ghost-btn-wrap" v-show="showBoxs1" style="z-index:777;">-->
                <!--<div style="width:100%;height:65px;position:relative;">-->
                    <!--<img class="imgposition" src="../../../images/transfer.png" alt="">-->
                <!--</div>-->
                <!--<div style="margin-top:20px;">-->
                    <!--<p style="color:#333;text-align: center;font-weight: bold;">是否确定为该患者加号？</p>-->
                <!--</div>-->
                <!--<div style="margin-top:30px;width:70%;margin-left:15%;">-->
                    <!--<p style="color:#8A8A8A;text-align: center;font-size: 14px;line-height:24px;">提示：对于异地转诊患者，如是复诊患者，可直接加号；如是初诊患者，系统会对患者进行实名认证，认证通过后在线建档，再加号。</p>-->
                <!--</div>-->
                <!--<div style="position:relative;margin-top:50px;">-->
                    <!--<el-button-->
                            <!--type="ghost"-->
                            <!--style="position:absolute;width:150px;right:50px;top:0;"-->
                            <!--@click="closeBoxs1"-->
                            <!--class="ghost-btn">返回-->
                    <!--</el-button>-->
                    <!--<el-button-->
                            <!--type="primary"-->
                            <!--class="submit-btn blue-btn h36 w200 "-->
                            <!--@click="SureTransf1"-->
                            <!--style="position:absolute;left:50px;top:0;">-->
                            <!--加号-->
                    <!--</el-button>-->
                <!--</div>-->
            <!--</div>-->
            <div class="ssts1 ghost-btn-wrap" v-show="showBoxs1">
                <div style="width:100%;height:65px;position:relative;">
                    <img class="imgposition" src="../../../images/transfer.png" alt="">
                </div>
                <div style="margin-top:20px;">
                    <p style="color:#333;text-align: center;font-weight: bold;">是否确定为该患者加号？</p>
                </div>
                <div style="margin-top:30px;width:70%;margin-left:15%;">
                    <p style="color:#8A8A8A;text-align: center;font-size: 14px;line-height:24px;">提示：对于异地转诊患者，如是复诊患者，可直接加号；如是初诊患者，系统会对患者进行实名认证，认证通过后在线建档，再加号。</p>
                </div>
                <div style="margin-top:20px;">
                    <el-select
                            v-model="initHosId"
                            size="small"
                            style="margin-left:5px;"
                            class="launch-input w150 h24"
                            filterable
                            :loading="loading"
                            placeholder="请选择申请医院"
                            @change="getInitHospId">
                        <el-option v-for="item in hospListZ" :label="item.yymc" :value="item.yyid" :key="item.yyid"/>
                    </el-select>
                    <el-select
                            v-model="initDeptId"
                            size="small"
                            style="margin-left:5px;"
                            class="launch-input w150 h24"
                            filterable
                            @visible-change="getInitDeptList"
                            @change="getInitDeptId"
                            :loading="loading"
                            placeholder="请选择申请科室">
                        <el-option v-for="item in initDeptList" :label="item.ksmc" :value="item.ksid" :key="item.ksid"/>
                    </el-select>
                    <el-select
                            v-model="initDocId"
                            size="small"
                            style="margin-left:5px;"
                            class="launch-input w150 h24"
                            filterable
                            :loading="loading"
                            @visible-change="getInitDocList"
                            @change="getInitDocId"
                            placeholder="请选择申请医生">
                        <el-option v-for="item in initDocList" :label="item.ysxm" :value="item.ysid" :key="item.ysid"/>
                    </el-select>
                </div>
                <div style="position:relative;margin-top:50px;">
                    <el-button
                            type="ghost"
                            style="position:absolute;width:150px;left:50px;top:0;"
                            @click="closeBoxs1"
                            class="ghost-btn">返回
                    </el-button>
                    <el-button
                            type="primary"
                            class="submit-btn blue-btn h36 w200 "
                            @click="SureTransf1"
                            style="position:absolute;right:50px;top:0;">
                        加号
                    </el-button>
                </div>
            </div>



               <div class="ssts" v-show="showBox">

            </div>
        </div>
        <router-view></router-view>
    </div>
</template>
<style>
    .cc{
        color:#666666;
    }
    .aa{
        border:1px solid #92412B !important;
        color:#92412B;
    }
</style>
<script type="es6">
    import AddDoctorMsgBox from "../common/AddDoctorMsgBox.vue";
    import { Button, Radio, RadioGroup, Select, Option, DatePicker, Input, Message, Loading, Popover, MessageBox } from "element-ui";
    import axiosUtil from "../../utils/AxiosUtils.js"
    import fileClassification from "../../utils/FileClassificationUtils";
    import ImageAmplify from "../common/ImageAmplify.vue";
    import { formatUnixTime, formatTimeToUnix,formatTimeStamp } from "../../utils/DateFormat.js";
    import html2Escape from "../../utils/Html2Escape"
    import { imageAmplify } from "../../utils/ImageAmplify.js";
    import axiosUtilz from "../../utils/AxiosUtilz.js";
    import { showTestVideo } from "../../utils/VideoTestUtils";
    import {closeImg} from "../../utils/ImageAmplify.js";
    import { DirectEnterConf}  from "../../utils/hushi-video.js";
    import Vue from "vue";
    import {selectVideoChannelMixin} from "../../lib/mixins"
    Vue.use(Button);
    Vue.use(Radio);
    Vue.use(RadioGroup);
    Vue.use(Select);
    Vue.use(Option);
    Vue.use(DatePicker );
    Vue.use(Loading);
    Vue.use(Popover);
    export default{
        data: function(){
            return {
                showsY:false,
                hzysid:"",
                bah:"",
                hzsqyymc:"",
                hzsqksmc:"",
                hzsqysxm:"",
                hzsqyyid:"",
                zzqk:"",
                bahms:"",
                hzsj:"",
                beforeDiagnose:"",
                areaNameArr:[],
                kh:"",
                zs:"",
                hy:"",
                lxdz:"",
                banhms:"",
                showBoxs1:false,
                showBox2:false,
                showBox1:false,
                showBox5:false,
                showBox6:false,
                showBox4:false,
                showBox3:false,
                consulterName:"",
                consulterMobile:"",
                consulterJob:"",
                showBox:false,
                maritalStatus:"",
                shows6:false,
                consulterDiagnoseLevel :"",
                transFer:"",
                transFer2:"",
                showsVideo:false,
                version:"",
                showVideos:false,
                showscci:false,
                showshushi:false,
                submits:false,
                consulterIdcard:"",
                record:true,
                shows11:true,
                shows10:false,
                shows8:true,
                shows9:false,
                show4:true,
                show5:false,
                show6:true,
                show7:false,
                mark:localStorage.getItem('hosMark'),
                identity:JSON.parse(localStorage.getItem('userInfo')).doc.docType,
                clickname:'1',
                clickName:'1',
                clickname1:'3',
                clickName1:'3',
                consultDetail: {},//会诊单详细信息
                dataReady: 1,//资料是否就绪
                isArrange: 1,//是否安排会诊
                isArrangeSelect: false,//安排医生input框是否能够编辑disabled值
                isDataReadySelect: false,//资料是否就绪input框是否能够编辑disabled值
                remark: "您提交的资料不完整，请提交资料",//资料缺失内容
                selectDate: "",//选择会诊时间
                oldDate: "",// 上次安排的会诊时间，用于判断提交时是否需要更新时间
                rejectContent: "",//拒绝会诊理由
                isShowAddDocBox: false,//是否显示邀请医生弹出窗
                isSuccess: false,//是否加载成功
                isReject: false,//是否已经拒绝成功
                treatDocName: JSON.parse(sessionStorage.getItem("loginInfo")).docName,//是否安排会诊处理医生

                isEnd: false,//是否能够结束视频
                isEntry: false,//是否能够进入视频
                isTest: false,//是否是进入测试环境
                isShowVideo: false,//是否显示视频窗口(当提交安排会诊后显示，拒绝无法显示)
                isVideoReady: false,//视频是否准备完成
                videoSrc: "",//视频src地址

                perfectList: [],// 补充资料历史记录
                isShowPerfectList: false,// 是否显示补充资料记录列表

                acceptHosId: "",//期望医院ID
                acceptDeptId: "",//期望科室
                acceptDocId: "",//期望医生ID
                hopeDocId:"",
                initDocId:"",
                initHosId:"",
                initDeptId:"",
                initDocList:[],
                initDeptList:[],
                hospListZ:[],
                hosList: [],//获取医院列表
                deptList: [],//获取科室列表
                docList: [],//获取医生列表
                loading: false,//是否正在从远程获取数据

                imgList: [],//附件图片列表
                fileList: [],//附件文件列表
                docIds:"",
                showClassList:{},
                form:{//互视频视频
                    txtServerAddress:"114.55.29.216",
                    txtServerPort:"17979",
                    txtUserNickname:JSON.parse(sessionStorage.getItem("loginInfo")).doc.docName,
                    txtConfID:""}
            }
        },
        created: function(){//获取会诊单数据
            this.getConsultDetail();
            this.$store.dispatch("changeSideItem", "ychz");//侧边栏高亮
        },
        watch: {
            // 如果路由有变化，会再次执行获取会诊单方法
            "$route": "getConsultDetail",
            "endConsult": function (newVal, oldVal) {// 如果推送已完成，跳转到评论
                if(newVal == true){
                    this.isShowVideo = false;
                    this.$router.push({ name: "remoteEvaluate", params: { consultId: this.consultId }} );
                }
            },
            "refreshConsult": function(newVal, oldVal) {// 如果补充了资料则重新刷新
                if(newVal === true){
                    this.getConsultDetail();
                    this.$store.dispatch("getRefreshConsultId", null);// 初始化需要刷新的id
                }
            }
        },
        components:{
            ImageAmplify,
            AddDoctorMsgBox
        },
        mixins:[selectVideoChannelMixin],
        computed: {
            consultId: function(){//获取会诊单编号
                return this.$route.params.consultId;//获取会诊单编号
            },
            isArrangeTime: function(){//会诊单是否已经安排过时间且已经审核
                return this.consultDetail.consultGroup.consultTime&&this.consultDetail.consultGroup.readyStatus;
            },
            inviteVoList: function () {//获取已经邀请的医生列表
                return this.$store.state.inviteVoList;
            },
            acceptDoc: function () {//期望医生
                let consult = this.consultDetail.consultGroup;
                if(consult.hopeHosName&&consult.hopeDeptName){
                    if(consult.hopeDocName){
                        return consult.hopeHosName + ' - ' + consult.hopeDeptName + ' - ' + consult.hopeDocName;
                    }else {
                        return consult.hopeHosName + ' - ' + consult.hopeDeptName;
                    }
                }else {
                    return '无';
                }
            },
            endConsult: function() {//动态检查患者是否结束视频
                return this.$store.state.endConsultId==this.consultId;
            },
            refreshConsult: function() {// 动态检查患者是否补充了资料，进行重新刷新
                return this.$store.state.refreshConsultId == this.consultId;
            }
        },
        beforeDestroy: function(){//组件销毁前如果视频房间未退出则调用退出接口
        },
        mounted:function(){
//            this.getVideo();
            this.getHospList();
            this.getVersion();
        },
        methods: {
            getInitHospId: function (hospId) {//获取选择申请的医院id
                let _this = this;
                _this.initHosId = hospId;


                for (var i = 0; i < _this.hospListZ.length; i++) {
                    if (_this.initHosId == _this.hospListZ[i].yyid) {
                        _this.zyyymc = _this.hospListZ[i].yymc
                    }
                }
                // _this.initDeptId = "";
                // _this.initDocId = "";
                _this.getInitDeptList();
            },
            getInitDeptList: function (query) {//获取申请科室列表
            if(this.initHosId){
                    this.loading = true;
                    let _this = this;
                    let options = {
                        yyid: _this.initHosId,
                        service: "smarthos.sxzz.outdept.list"
                    };
                    axiosUtilz(options, function(data){

                        _this.loading = false;
                        _this.initDeptList = data.list;
                    });
                }else{
                    Message({
                        showClose: true,
                        message: "请先选择医院",
                        type: "info"
                    });
                    return;
                }
            },
            getInitDeptId: function (deptId) {// 获取申请科室id
                let _this = this;
                _this.initDeptId = deptId;
                for (var i = 0; i < _this.initDeptList.length; i++) {
                    if (_this.initDeptId == _this.initDeptList[i].ksid) {
                        _this.zyksmc = _this.initDeptList[i].ksmc
                    }
                }
                _this.initDocId = "";
                _this.getInitDocList();
            },
            getInitDocList: function (query) {//获取医生列表
                if (this.initDeptId && this.initHosId) {//如果医院和科室已经选择完成则可以选择科室
                    this.loading = true;
                    let _this = this;
                    let options = {
                        yyid: _this.initHosId,
                        ksid: _this.initDeptId,
                        service: "smarthos.sxzz.outdoc.list"
                    };
                    axiosUtilz(options, function (data) {
                        _this.loading = false;
                        _this.initDocList = data.list;
                    });
                } else {
                    
                    Message({
                        showClose: true,
                        message: "请先选择科室",
                        type: "info"
                    });
                    return;
                }
            },
            getInitDocId: function (docId) {//获取申请的医生id
                let _this = this;
                // _this.initDocId = docId;

                for (var i = 0; i < _this.initDocList.length; i++) {
                    if (_this.initDocId == _this.initDocList[i].ysid) {
                        _this.zyysxm = _this.initDocList[i].ysxm
                    }
                }
            },
            closeBox: function () {
                let _this = this;
                _this.showBox = false;
                _this.showBox1 = false;
                _this.showBox6 = false;
                // _this.initDeptId ="";
                // _this.initDocId ="";

            },
            getHosTransfer: function () {
                let _this = this;
                _this.showBox = true;
                _this.showBox1 = true;
                let options = {
                    service: "smarthos.sxzz.mzhos.list"
                };
                axiosUtilz(options, function (data) {
                    _this.hospListZ = data.list;
                })
            },
            getHosTransfer2:function(){
                let _this=this;
                _this.showBox=true;
                _this.showBox6=true;
                let options={
                    service:"smarthos.sxzz.mzhos.list"
                };
                axiosUtilz(options,function(data){
                    _this.hospListZ=data.list;
                })
            },
            closeBoxs1: function () {
                let _this = this;
                _this.showBoxs1 = false;
                _this.showBox = false;
                // _this.initDeptId ="";
                // _this.initDocId ="";
            },
            showjpg: function () {
                let _this = this;
                _this.showBox3 = true;
            },
            closeBox3: function () {
                let _this = this;
                _this.showBox3 = false;
            },
            closeBox2:function(){
                let _this=this;
                _this.showBox2=false;
                _this.showBox=false;
            },
            closeBox4:function(){
                let _this=this;
                _this.showBox4=false;
                _this.showBox=false;
            },
            closeBox5:function(){
                let _this=this;
                _this.showBox5=false;
                _this.showBox=false;
            },
            getHosTransfer1: function () {
                let _this = this;
                _this.showBoxs1 = true;
                _this.showBox = true;
                let options = {
                    service: "smarthos.sxzz.mzhos.list"
                };
                axiosUtilz(options, function (data) {
                    _this.hospListZ = data.list;
                });
                let options1 = {
                    docId: _this.hzysid,
                    token: localStorage.getItem("token"),
                    Service: "smarthos.user.doc.card.get"
                }
                axiosUtil(options1, function (data) {

                    _this.showClassList = {
                        hzstartTime: formatUnixTime(_this.hzstartTime),
                        hzendTime: formatUnixTime(_this.hzendTime),
                        hzid: _this.consultId,
                        hzsj: formatUnixTime(_this.hzsj),
                        yhxm: _this.consulterName,
                        zjhm: _this.consulterIdcard,
                        kh: _this.kh,
                        zs: _this.zs,
                        hy: _this.hy,
                        lxdz: _this.lxdz,
                        sjhm: _this.consulterMobile,
                        zy: _this.consulterJob ? _this.consulterJob : "",
                        zxyj: _this.consultAdvice,
                        areaNameArr: _this.areaNameArr,//省市区

                        sqyymc: _this.hzsqyymc,
                        sqyyid: _this.hzsqyyid,
                        sqksmc: _this.hzsqksmc,
                        sqysxm: _this.hzsqysxm,
                        sqysid: JSON.parse(sessionStorage.getItem("loginInfo")).doc.id,

                        yymc: _this.zyyymc,
                        yyid: '085101',
                        ksid:_this.initDeptId,
                        ksmc: _this.zyksmc,
                        ysxm: _this.zyysxm,
                        ysid: _this.initDocId,
                        hzbqqq: _this.consulterDiagnoseLevel,
                        cbzd: _this.beforeDiagnose,
                        tpwjdzs: _this.tpwjdzs,
                        fjwjdzs: _this.fjwjdzs,
                        platDocList: data.obj.doc
                    }

                })
            },


            SureTransf: function () {
                let _this = this;

                if(_this.initHosId==""){
                    Message({
                        message: "请选择医院！",
                        type: "warning"
                    });
                    return
                }
                let service = "";
                if(_this.showBox6){//住院转诊
                    service = "smarthos.sxzz.hzzyzz.info"
                }else if(_this.showBox1){//急诊转诊
                    service = "smarthos.sxzz.hzzz.info"
                }

                let options = {
                    hzstartTime: formatUnixTime(_this.hzstartTime),
                    hzendTime: formatUnixTime(_this.hzendTime),
                    hzid: _this.consultId,
                    lxdz: _this.lxdz,
                    hzsj: formatUnixTime(_this.hzsj),
                    yhxm: _this.consulterName,
                    zjhm: _this.consulterIdcard,
                    kh: _this.kh,
                    areaNameArr: _this.areaNameArr,
                    sjhm: _this.consulterMobile,
                    zy: _this.consulterJob ? _this.consulterJob : "",
                    zxyj: _this.consultAdvice,
                    hy: _this.hy,
                    zs: _this.zs,

                    sqyymc: _this.hzsqyymc,
                    sqyyid: _this.hzsqyyid,
                    sqksmc: _this.hzsqksmc,
                    sqysxm: _this.hzsqysxm,
                    sqysid: JSON.parse(sessionStorage.getItem("loginInfo")).doc.id,

                    yymc: _this.zyyymc,
                    yyid: _this.initHosId,
                    // yyid: '085101',
                    ksid: _this.initDeptId,
                    ysid: _this.initDocId,
                    ksmc: _this.zyksmc,
                    ysxm: _this.zyysxm,
                    cbzd: _this.beforeDiagnose,
                    tpwjdzs: _this.tpwjdzs,
                    fjwjdzs: _this.fjwjdzs,
                    service: service,
                };
                _this.showClassList = _this.options;
                axiosUtilz(options, function (data) {

                    if (data.code == "1") {
//                        建档成功
                        _this.showBox2 = true;
                        _this.showBox1 = false;
                        _this.showBox6 = false;
                        _this.showBox = true;
                        window.localStorage.setItem("ZZQK"+_this.docIds,data.obj.zzqk);
                        _this.zzqk = localStorage.getItem("ZZQK"+_this.docIds)?localStorage.getItem("ZZQK"+_this.docIds):"暂未转诊";
                        _this.bah = data.obj.bah;
                    } else if (data.code == "3") {
//                        建档失败，实名认证失败
                        _this.showBox4 = true;
                        _this.showBox1 = false;
                        _this.showBox6 = false;
                        _this.showBox = true;
                        window.localStorage.setItem("ZZQK"+_this.docIds,data.obj.zzqk);
                        _this.zzqk = localStorage.getItem("ZZQK"+_this.docIds)?localStorage.getItem("ZZQK"+_this.docIds):"暂未转诊";
                        _this.bahms = data.obj.bahms;
                    } else if (data.code == "2") {
//                        已经建档
                        _this.showBox5 = true;
                        _this.showBox1 = false;
                        _this.showBox6 = false;
                        window.localStorage.setItem("ZZQK"+_this.docIds,data.obj.zzqk);
                        _this.zzqk = localStorage.getItem("ZZQK"+_this.docIds)?localStorage.getItem("ZZQK"+_this.docIds):"暂未转诊";
                        _this.bah = data.obj.bah;
                    }
                }, function (err) {

                    if (err.code == "-1") {
                        _this.showBox1 = false;
                        _this.showBox6 = false;
                        _this.showBox=false;
                        _this.bah = err.obj.bah;
                        window.localStorage.setItem("ZZQK"+_this.docIds,err.obj.zzqk);
                        _this.zzqk = localStorage.getItem("ZZQK"+_this.docIds)?localStorage.getItem("ZZQK"+_this.docIds):"暂未转诊";
                    }
                })
            },
            SureTransf1: function () {//门诊加号
                let _this = this;
                // _this.showBoxs1 = false;
                // _this.showBox = false;
                if(_this.initDeptId!=""){
                    _this.showBoxs1 = false;
                    _this.showBox = false;
                }else{
                    _this.showBoxs1 = true;
                    _this.showBox = true;

                    Message({
                        showClose: true,
                        message: "请选择科室",
                        type: "warning"
                    });
                    return
                }

                let options = {
                    docId: _this.hzysid,
                    token: localStorage.getItem("token"),
                    Service: "smarthos.user.doc.card.get"
                }
                axiosUtil(options, function (data) {
                    _this.showClassList = {
                        hzstartTime: formatUnixTime(_this.hzstartTime),
                        hzendTime: formatUnixTime(_this.hzendTime),
                        hzid: _this.consultId,
                        hzsj: formatUnixTime(_this.hzsj),
                        yhxm: _this.consulterName,
                        zjhm: _this.consulterIdcard,
                        kh: _this.kh,
                        zs: _this.zs,
                        hy: _this.hy,
                        lxdz: _this.lxdz,
                        sjhm: _this.consulterMobile,
                        zy: _this.consulterJob ? _this.consulterJob : "",
                        zxyj: _this.consultAdvice,
                        areaNameArr: _this.areaNameArr,//省市区

                        sqyymc: _this.hzsqyymc,
                        sqyyid: _this.hzsqyyid,
                        sqksmc: _this.hzsqksmc,
                        sqysxm: _this.hzsqysxm,
                        ysid: _this.initDocId,
                        sqysid: JSON.parse(sessionStorage.getItem("loginInfo")).doc.id,

                        yymc: _this.zyyymc,
                        // yyid: '085101',
                        yyid:_this.initHosId,

                        ksmc: _this.zyksmc,
                        ksid: _this.initDeptId,
                        ysxm: _this.zyysxm,

                        hzbqqq: _this.consulterDiagnoseLevel ,
                        cbzd: _this.beforeDiagnose,
                        tpwjdzs: _this.tpwjdzs,
                        fjwjdzs: _this.fjwjdzs,
                        platDocList: data.obj.doc
                    }


                        _this.$router.push({name: "showClassListS", params: {showObj: _this.showClassList}});

                })
            },

            getVersion: function () {
                let _this = this;
                let options = {
                    Service: "smarthos.system.param.string",
                    key: "VIDEO_SP_HUSHI_PC_BUILD_VERSION",
                    defaultString: "1"
                }
                axiosUtil(options, function (data) {

                    _this.version = data.obj;
                })
            },
            getrecord:function(){
                let _this=this;

            },
            linkToCx:function(){
                let _this=this;

                if(_this.consulterIdcard!=""){
                    let options={
                        idCard:_this.consulterIdcard,
                        token: localStorage.getItem("token"),
                        Service:"smarthos.book.emr.patient"
                    }
                    axiosUtil(options,function(data){
                            if(data.list){
                                if(data.list.length>0){
                                    window.localStorage.setItem("patInfo", JSON.stringify(data.list[0]));
                                    window.open("./?from=ins#/linkCx");
                                }else{
                                    Message({
                                        showClose: true,
                                        message: "该身份证号在长兴医院没有病历",
                                        type: "warning"
                                    });
                                }
                            }else{
                                Message({
                                    showClose: true,
                                    message: "该身份证号在长兴医院没有病历",
                                    type: "warning"
                                });
                            }
                    })
                }else{
                    Message({
                        showClose: true,
                        message: "请输入18位身份证号",
                        type: "warning"
                    });
                }
            },
            jybg:function(){
                this.shows10=true;
                this.show4=false;
                this.show5=true;
                this.clickName="2";
                this.$set(this.$data,'clickname','2')
                this.dataReady="0";
            },
            jcbg:function(){
                this.shows10=false;
                this.show4=true;
                this.show5=false;
                this.clickName="1";
                this.$set(this.$data,'clickname','1')
                this.dataReady="1";
            },
            jybg1:function(){
                this.shows11=false;
                this.isArrangeSelect=true;
                this.show6=false;
                this.shows8=false;
                this.shows9=true;
                this.show7=true;
                this.clickName1="4";
                this.$set(this.$data,'clickname1','4');
                this.isArrange="0";
            },
            jcbg1:function(){
                this.isArrangeSelect=false;
                this.shows8=true;
                this.shows9=false;
                this.show6=true;
                this.show7=false;
                this.clickName1="3";
                this.$set(this.$data,'clickname1','3');
                this.isArrange="1";
            },
            formatUnix: function(time, type="yyyy-MM-dd HH:mm"){//将unix时间戳转换未yyyy-MM-dd HH:mm
                return formatUnixTime(time, type);
            },
            createTimeStamp: function(){//创建处理表单unix时间戳
                return formatTimeStamp();
            },
            getConsultDetail: function(){//根据consultId获取会诊单数据
                this.isSuccess = false;
                let _this = this;
                let options = {
                    consultId: _this.consultId,
                    token: localStorage.getItem("token"),
                    Service: "smarthos.consult.group.detail"
                };
                axiosUtil(options, function(data){
                    _this.isSuccess = true;
                    _this.docIds=data.obj.consultGroup.id;
                    _this.zzqk=localStorage.getItem("ZZQK"+_this.docIds)?localStorage.getItem("ZZQK"+_this.docIds):"暂未转诊"
                    if(localStorage.getItem("txtConfID"+_this.docIds)){
                        _this.showsVideo=true;
                    }
                    // if(_this.mark<0){//上级医院显示转诊按钮
                    //     if(data.obj.consultGroup.transfer==true){
                    //         _this.transFer="0";
                    //         _this.transFer2=true;
                    //
                    //     }else{
                    //         _this.transFer="1";
                    //         _this.transFer2=false;
                    //
                    //     }
                    // }else{//下级医院不显示转诊按钮
                    //     _this.transFer="";
                    //     _this.transFer2=false;
                    //
                    // }

                    if(data.obj.consultGroup.consulterDiagnoseLevel){
                        if(data.obj.consultGroup.transfer==false){
                            _this.transFer="0";
                            _this.transFer2=true;


                        }else{
                            _this.transfer="1";
                            _this.transFer2=false;


                        }
                    }else{
                        _this.transFer="";
                        _this.transFer2=false;
                    }

                    if(data.obj.consultGroup.consultStatus ==="CANCEL") {// 如果当前状态不是进行中而是已取消
                        _this.$store.dispatch("getSideBarTitle", "已取消");
                        _this.$store.dispatch("getCurrentPosition", "ychz_yqx");// 更改侧边栏列表获取数据
                        _this.$router.push({ name: "remoteEvaluate", params: { consultId: _this.consultId }} );
                    }else if(data.obj.consultGroup.consultStatus ==="NEEDCOMMENT"||data.obj.consultGroup.consultStatus ==="FINSH"){// 已经完成
                        _this.$store.dispatch("getSideBarTitle", "已完成");
                        _this.$store.dispatch("getCurrentPosition", "ychz_ywc");// 更改侧边栏列表获取数据
                        _this.$router.push({ name: "remoteEvaluate", params: { consultId: _this.consultId }} );
                    }else if(data.obj.consultGroup.consultStatus ==="GOING") {// 如果当前状态不是进行中而是已取消
                        //如果已经安排完成，则获取已安排的医生信息
                        if (data.obj.consultGroup.consultTime) {
                            _this.$store.dispatch("getSideBarTitle", "待会诊");
                            _this.$store.dispatch("getCurrentPosition", "ychz_dhz");// 更改侧边栏列表获取数据
                            _this.acceptDocId = data.obj.consultGroup.acceptDocId;
                            _this.acceptDeptId = data.obj.consultGroup.acceptDeptId;
                            _this.acceptHosId = data.obj.consultGroup.acceptHosId;
                            _this.getDeptList();
                            _this.getDocList();
                            _this.hosList = [{
                                "hosName": data.obj.consultGroup.acceptHosName,
                                "id": data.obj.consultGroup.acceptHosId
                            }];
                            _this.deptList = [{
                                "deptName": data.obj.consultGroup.acceptDeptName,
                                "id": data.obj.consultGroup.acceptDeptId
                            }];
                            _this.docList = [{
                                "docName": data.obj.consultGroup.acceptDocName,
                                "id": data.obj.consultGroup.acceptDocId
                            }];
                            _this.selectDate = formatUnixTime(data.obj.consultGroup.consultTime);
                            if( _this.selectDate!=""){
                                _this.showsY=true;
                            }
                            _this.oldDate = formatUnixTime(data.obj.consultGroup.consultTime);
                        } else {//如果未安排医生，则选择医生栏默认选择发起医生希望会诊的医生
                            _this.$store.dispatch("getSideBarTitle", "处理中(我的)");
                            _this.$store.dispatch("getCurrentPosition", "ychz_clz");// 更改侧边栏列表获取数据
                            //获取期望医生id，为默认选择医生id
                            _this.acceptDocId = data.obj.consultGroup.hopeDocId?data.obj.consultGroup.hopeDocId:data.obj.consultGroup.acceptDocId;
                            _this.acceptDeptId = data.obj.consultGroup.hopeDeptId?data.obj.consultGroup.hopeDeptId:data.obj.consultGroup.acceptDeptId;
                            _this.acceptHosId = data.obj.consultGroup.hopeHosId?data.obj.consultGroup.hopeHosId:data.obj.consultGroup.acceptHosId;
                            _this.getDeptList();
                            _this.getDocList();
                            //获取显示列表，
                            _this.hosList = [{
                                "hosName": data.obj.consultGroup.hopeHosName?data.obj.consultGroup.hopeHosName:data.obj.consultGroup.acceptHosName,
                                "id": data.obj.consultGroup.hopeHosId?data.obj.consultGroup.hopeHosId:data.obj.consultGroup.acceptHosId
                            }];
                            _this.deptList = [{
                                "deptName": data.obj.consultGroup.hopeDeptName? data.obj.consultGroup.hopeDeptName: data.obj.consultGroup.acceptDeptName,
                                "id": data.obj.consultGroup.hopeDeptId?data.obj.consultGroup.hopeDeptId:data.obj.consultGroup.acceptDeptId
                            }];
                            _this.docList = [{
                                "docName": data.obj.consultGroup.hopeDocName?data.obj.consultGroup.hopeDocName:data.obj.consultGroup.acceptDocName,
                                "id": data.obj.consultGroup.hopeDocId?data.obj.consultGroup.hopeDocId:data.obj.consultGroup.acceptDocId
                            }];
                        }
                        //资料是否审核
                        if (!data.obj.consultGroup.auditStatus && data.obj.consultGroup.remark) {//如果资料状态未审核并且补充资料说明不为空，则为审核过资料并且未就绪
                            _this.remark = data.obj.consultGroup.remark;
                            _this.clickname="2";
                            _this.shows10=true;
                            _this.show5=true;
                        } else if (data.obj.consultGroup.readyStatus) {// 资料审核完成
                            _this.dataReady = 1;
                            _this.remark = "";
                        } else if (!data.obj.consultGroup.readyStatus && !data.obj.consultGroup.auditStatus && !data.obj.consultGroup.remark) {// 如果补充内容字段不存在，并且另外两个状态为false表示第一次接收到会诊单，默认按钮应该在资料就绪按钮上
                            _this.dataReady = 1;
                            _this.remark = "";
                        } else if (!data.obj.consultGroup.readyStatus && data.obj.consultGroup.auditStatus) {// 表示下级医生补充过资料，但是上级医生未审核
                            _this.remark = data.obj.consultGroup.remark;
                        }
                        _this.consultDetail = data.obj;
                        _this.consulterMobile=data.obj.consultGroup.consulterMobile;
                        _this.consulterName=data.obj.consultGroup.consulterName;
                        _this.consulterIdcard = data.obj.consultGroup.consulterIdcard;//患者证件号
                        _this.hzysid=data.obj.consultGroup.acceptDocId;
                        _this.kh=data.obj.consultGroup.consulterInhosno;
                        _this.beforeDiagnose=data.obj.consultGroup.beforeDiagnose;
                        _this.zs=data.obj.consultGroup.consultContent;
                        _this.hy=data.obj.consultGroup.maritalStatus;
                        _this.hzsj=data.obj.consultGroup.consultTime;
                        _this.lxdz=data.obj.consultGroup.consulterAddress;
                        _this.consulterJob=data.obj.consultGroup.consulterJob;
                        _this.hzsqysxm=data.obj.consultGroup.initDocName;
                        _this.hzsqksmc=data.obj.consultGroup.initDeptName;
                        _this.consulterDiagnoseLevel=data.obj.consultGroup.consulterDiagnoseLevel;
                        _this.hzsqyymc=data.obj.consultGroup.initHosName;
                        _this.hzsqyyid=data.obj.consultGroup.initHosId;
                        _this.areaNameArr=data.obj.areaNameArr;
                        if (data.obj.consultGroup.maritalStatus=="0") {
                          _this.maritalStatus="未婚";
                        }else if(data.obj.consultGroup.maritalStatus=="1"){
                            _this.maritalStatus="已婚";
                       }else if(data.obj.consultGroup.maritalStatus=="2"){
                            _this.maritalStatus="离异";
                        }else if(data.obj.consultGroup.maritalStatus=="3"){
                            _this.maritalStatus="不详";
                        }
                        _this.consulterIdcard = data.obj.consultGroup.consulterIdcard;//患者证件号
                        _this.getrecord();
                        //如果已经安排完成,获取时间
                        if (data.obj.consultGroup.consultTime) {
                            _this.selectDate = formatUnixTime(data.obj.consultGroup.consultTime);
                        }
                        //获取邀请医生列表
                        if (data.obj.inviteVoList) {
                            _this.$store.dispatch("getInviteDocList", data.obj.inviteVoList);
                        }
                        //获取附件并分组图片和文件
                        _this.fileList = [];//清空内容，否则使用路由跳转页面不重载时，可能会多个单子的附件一起push进来
                        _this.imgList = [];//清空内容，否则使用路由跳转页面不重载时，可能会多个单子的附件一起push进来
                        fileClassification(data.obj.attaList, _this.imgList, _this.fileList);
                    }
                }, function () {
                    _this.isSuccess = true;
                    _this.$router.go(-1);
                });
            },
            handleImageAmplify:function(index=0, imgList=[], ev){//放大图片
                let e = ev || event;
                let element = e.target || e.srcElement;
                let src = element.src;
                let obj = {
                    imgList: imgList,
                    index: index
                };
                this.$store.dispatch("getAmplifyImageArr", obj);// 储存需要放大的数组，用于左右按钮切换
                imageAmplify(src);
            },
            linkToEnterHushi:function(){
                let _this = this;
                if(localStorage.getItem("txtConfID"+_this.docIds)){
                    _this.form.txtConfID=localStorage.getItem("txtConfID"+_this.docIds);
                    DirectEnterConf(_this.form).then((res)=>{
                        if(res.result=="1012"){
                            Message({
                                showClose: true,
                                message: "客户端已经启动，请确认!",
                                type: "success"
                            });
                        }else if(res.result=="0"){
                            Message({
                                showClose: true,
                                message: "客户端正在启动，请稍等...",
                                duration:15000,
                                type: "success"
                            });
                            let strs=res.message.split(".")
                            let strd=_this.version.split(".")
                            let strss=[];
                            let strdd=[];
                            for(var i=0;i<strs.length;i++){
                                strss.push(strs[i]);
                            }
                            for(var j=0;j<strs.length;j++){
                                strdd.push(strd[j]);
                            }
                            if(strss[0]<strdd[0]||strss[1]<strdd[1]||strss[2]<strdd[2]||strss[3]<strdd[3]){
                                MessageBox.confirm('抱歉，您的客户端不是最新版本，是否下载最新版本？', '提示',{
                                    confirmButtonText: '确定下载',
                                    showCancelButton:false,
                                    type: 'warning'
                                }).then(()=>{
                                    window.location.href="http://ih.womanhospital.cn/download/Hospital_Setup.exe"
                                })
                            }else if(strss[0]==strdd[0]||strss[1]==strdd[1]||strss[2]==strdd[2]||strss[3]==strdd[3]){
                            }else if(strss[0]>strdd[0]||strss[1]>strdd[1]||strss[2]>strdd[2]||strss[3]>strdd[3]){                            
                            }
                        }else if(res.result=="1011"){
                            MessageBox.confirm('请先安装视频客户端', '提示',{
                                confirmButtonText: '确定下载',
                                showCancelButton:false,
                                type: 'warning'
                            }).then(()=>{
                                window.location.href="http://ih.womanhospital.cn/download/Hospital_Setup.exe"
                            })
                        }
                    }).catch(()=>{
                        MessageBox.confirm('请先安装视频客户端', '提示',{
                            confirmButtonText: '确定下载',
                            showCancelButton:false,
                            type: 'warning'
                        }).then(()=>{
                            window.location.href="http://ih.womanhospital.cn/download/Hospital_Setup.exe"
                        })
                    });
                }else{
                    let options = {
                        consultId: _this.consultId,
                        token: localStorage.getItem("token"),
                        Service: "smarthos.consult.group.intovideo"
                    };
                    axiosUtil(options, function(data){
                        window.localStorage.setItem("txtConfID"+_this.docIds,data.obj.room.roomCallid);
                        _this.form.txtConfID=localStorage.getItem("txtConfID"+_this.docIds);
                        DirectEnterConf(_this.form).then((res)=>{
                            _this.showsVideo=true;
                            if(res.result=="1012"){
                                Message({
                                    showClose: true,
                                    message: "客户端已经启动，请确认!",
                                    type: "success"
                                });
                            }else if(res.result=="0"){
                                Message({
                                    showClose: true,
                                    message: "客户端正在启动，请稍等...",
                                    duration:15000,
                                    type: "success"
                                });
                                let strs=res.message.split(".")
                                let strd=_this.version.split(".")
                                let strss=[];
                                let strdd=[];
                                for(var i=0;i<strs.length;i++){
                                    strss.push(strs[i]);
                                }
                                for(var j=0;j<strs.length;j++){
                                    strdd.push(strd[j]);
                                }
                                if(strss[0]<strdd[0]||strss[1]<strdd[1]||strss[2]<strdd[2]||strss[3]<strdd[3]){
                                    MessageBox.confirm('抱歉，您的客户端不是最新版本，是否下载最新版本？', '提示',{
                                        confirmButtonText: '确定下载',
                                        showCancelButton:false,
                                        type: 'warning'
                                    }).then(()=>{
                                        window.location.href="http://ih.womanhospital.cn/download/Hospital_Setup.exe"
                                    })
                                }else if(strss[0]==strdd[0]||strss[1]==strdd[1]||strss[2]==strdd[2]||strss[3]==strdd[3]){
                                }else if(strss[0]>strdd[0]||strss[1]>strdd[1]||strss[2]>strdd[2]||strss[3]>strdd[3]){                                
                                }
                            }else if(res.result=="1011"){
                                MessageBox.confirm('请先安装视频客户端', '提示',{
                                    confirmButtonText: '确定下载',
                                    showCancelButton:false,
                                    type: 'warning'
                                }).then(()=>{
                                    window.location.href="http://ih.womanhospital.cn/download/Hospital_Setup.exe"
                                })
                            }
                        }).catch(()=>{
                            MessageBox.confirm('请先安装视频客户端', '提示',{
                                confirmButtonText: '确定下载',
                                showCancelButton:false,
                                type: 'warning'
                            }).then(()=>{
                                window.location.href="http://ih.womanhospital.cn/download/Hospital_Setup.exe"
                            })
                        });
                    });
                }
            },
            linkToEnter: function(type){//进入/测试视频
                    let _this = this;
                    let options = {
                        consultId: _this.consultId,
                        token: localStorage.getItem("token"),
                        Service: "smarthos.consult.group.intovideo"
                    };
                    axiosUtil(options, function(data){
                        let roomPassword = null;
                        let roomNo=data.obj.room.roomNo
                        if(data.obj.room.roomPassword){
                            roomPassword = data.obj.room.roomPassword;
                        }else{
                            roomPassword = data.obj.room.roomGhostPassword;
                        }
                        let options={
                            key:"CONSULT_GROUP_VIDEO_SP_NAME",
                            defaultString:"cci",
                            Service:"smarthos.system.param.string"
                        }
                        axiosUtil(options,function(data){
                                _this.isVideoReady = true;
                                _this.isShowVideo = true;
                                if(type!="test"){
                                    _this.$emit("showList");//显示视频间人员列表
                                    _this.isTest = false;
                                }else {
                                    _this.isTest = true;
                                }
                                let docName = JSON.parse(sessionStorage.getItem("loginInfo")).docName;
                                let src = encodeURI("https://webrtc.onecc.me/zl/?conference=" + roomNo + "&name=" + docName + "&pin=" + roomPassword + "&join=1");
                                setTimeout(function(){ _this.videoSrc = src; _this.isVideoReady = false; _this.isEnd=true;}, 0);
                        })
                    });
            },
            linkToEnterTest: function(){// 测试环境
                this.isTest = true;
                this.isShowVideo = true;
                this.$nextTick(() => {// 需要先更新dom否则获取不到video
                    showTestVideo(this.$refs.video);
                });
            },
            linkEnterHD: function(HDRoomNum){//高清设备
                let _this = this;
                _this.isTest = false;
                _this.videoSrc = "";// 防止第一次进入电脑接口，然后进入高清设备电脑端会有画面
                let accountNo = HDRoomNum ? HDRoomNum : "";
                let options = {
                    consultId: _this.consultId,
                    accountNo: accountNo,
                    token: localStorage.getItem("token"),
                    Service: "smarthos.consult.group.intovideo"
                };
                axiosUtil(options, function(data){
                    _this.isVideoReady = true;
                    _this.isShowVideo = true;
                    _this.$emit("showList");//显示视频间人员列表
                });
            },
            linkEnterHDTest: function(HDRoomNum){//高清设备
                let _this = this;
                _this.videoSrc = "";// 防止第一次进入电脑接口，然后进入高清设备电脑端会有画面
                let accountNo = HDRoomNum ? HDRoomNum : "";
                let options = {
                    consultId: _this.consultId,
                    accountNo: accountNo,
                    token: localStorage.getItem("token"),
                    Service: "smarthos.consult.group.intovideo"
                };
                axiosUtil(options, function(data){
                    _this.isVideoReady = true;
                    _this.isShowVideo = true;
                    _this.isTest = true;
                });
            },
            linkToOut: function(){//退出视频
                let _this = this;
                if(_this.isTest){// 测试环境
                    _this.isTest = false;
                    _this.isShowVideo = false;
                    _this.$refs.video.src = "";
                    return;
                }
                this.$emit("hiddenList");//隐藏视频间人员列表
                let options = {
                    consultId: _this.consultId,
                    token: localStorage.getItem("token"),
                    Service: "smarthos.consult.group.exitvideo"
                };
                axiosUtil(options, function(data){
                    _this.isShowVideo = false;
                    //_this.$router.push("/main/remoteConsultation");
                });
            },
            linkToEnd: function(){
                MessageBox.confirm('本次会诊已顺利完成，是否确定结束？(点击确定后无法再次进入视频)', '提示', {
                    confirmButtonText: '确定结束',
                    cancelButtonText: '再想想',
                    type: 'warning'
                }).then(() => {
                    let _this = this;
                    if(localStorage.getItem("txtConfID"+_this.docIds)){
                        localStorage.removeItem("txtConfID"+_this.docIds);
                    }
                    if(localStorage.getItem("ZZQK"+_this.docIds)){
                        localStorage.removeItem("ZZQK"+_this.docIds)
                    }
                    let options = {
                        consultId: _this.consultId,
                        token: localStorage.getItem("token"),
                        transFer:_this.transFer,
                        consulterDiagnoseLevel :_this.consulterDiagnoseLevel,
                        referralSituation:_this.zzqk,
                        Service: "smarthos.consult.group.complete"
                    };
                    axiosUtil(options, function(data){
                        _this.$router.push({ name: "remoteEvaluate", params: { consultId: _this.consultId }} );
                    });
                }).catch(() => {});
            },
            linkToCancel: function(){// 取消会诊
                MessageBox.confirm('是否确定取消会诊?', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(() => {
                    let _this = this;
                    let options = {
                        consultId: _this.consultId,
                        disagreeReason: "视频开始前取消",
                        token: localStorage.getItem("token"),
                        Service: "smarthos.consult.group.cancel"
                    };
                    axiosUtil(options, function(data){
                        _this.$router.push({ name: "remoteEvaluate", params: { consultId: _this.consultId }} );
                    });
                }).catch(() => {return;});
            },
            submitConsul: function(){//提交会诊单(安排时间医生)
                let _this = this;
                _this.submits=true;
                let options = null;
                if(_this.transFer=="0"){
                    _this.transFer=true
                }else{
                    _this.transFer=false
                }
                if(_this.dataReady==0){//要求补充资料
                        if(_this.selectDate&&_this.acceptDocId!==""){//填写医生和时间
                            options = {
                                consultId: _this.consultId,
                                consultTime: _this.selectDate?formatTimeToUnix(_this.selectDate):"",
                                auditStatus: false,
                                acceptDocId: _this.acceptDocId,
                                readyStatus: false,//资料未就绪需要审核
                                perfectReason: _this.remark?html2Escape(_this.remark):"",
                                transfer:_this.transFer,
                                consulterDiagnoseLevel :_this.consulterDiagnoseLevel,
                                token: localStorage.getItem("token"),
                                Service: "smarthos.consult.group.ass.process"
                            };
                        }else{//未同时填写医生和时间
                            options = {
                                consultId: _this.consultId,
                                auditStatus: false,
                                readyStatus: false,//资料未就绪需要审核
                                perfectReason: _this.remark?html2Escape(_this.remark):"",
                                transfer:_this.transFer,
                                consulterDiagnoseLevel :_this.consulterDiagnoseLevel,
                                token: localStorage.getItem("token"),
                                Service: "smarthos.consult.group.ass.process"
                            };
                        }
                }else {// 资料已经就绪
                    if(_this.selectDate&&_this.acceptDocId!==""&&_this.selectDate!==_this.oldDate){//已经填写医生和时间,并且安排时间和上次时间不同
                        options = {
                            consultId: _this.consultId,
                            consultTime:_this.selectDate?formatTimeToUnix(_this.selectDate):"",
                            auditStatus: true,
                            readyStatus: true,//资料就绪审核
                            acceptDocId: _this.acceptDocId,
                            transfer:_this.transFer,
                            consulterDiagnoseLevel :_this.consulterDiagnoseLevel,
                            token: localStorage.getItem("token"),
                            Service: "smarthos.consult.group.ass.process"
                        }
                    }else {
                        options = {
                            consultId: _this.consultId,
                            consultTime: _this.selectDate?formatTimeToUnix(_this.selectDate):"",
                            auditStatus: true,
                            acceptDocId: _this.acceptDocId,
                            readyStatus: true,//资料就绪审核
                            transfer:_this.transFer,
                            consulterDiagnoseLevel :_this.consulterDiagnoseLevel,
                            token: localStorage.getItem("token"),
                            Service: "smarthos.consult.group.ass.process"
                        };
                    }
                }
                axiosUtil(options, function(data){
                    _this.submits=false;
                    Message({
                        showClose: true,
                        message: "提交成功!",
                        type: "success"
                    });
                    _this.getConsultDetail();
                },function(data){
                    _this.submits=false;
                });
            },
            rejectConsul: function(){//拒绝会诊
                this.isReject = true;
                let _this = this;
                let options = {
                    consultId: _this.consultId,
                    disagreeReason: html2Escape(_this.rejectContent),
                    token: localStorage.getItem("token"),
                    Service: "smarthos.consult.group.cancel"
                };
                axiosUtil(options, function(data){
                    _this.isReject = false;
                    Message({
                        showClose: true,
                        message: "提交成功",
                        type: "success"
                    });
                    _this.$router.push("/main/RemoteConsulations");
                });
            },
            dataReadyChange: function(selectValue){//资料是否就绪单选框变化时调用
                if(selectValue === 1){//资料就绪
                    this.isDataReadySelect = false;
                } else if (selectValue === 0){
                    this.isDataReadySelect = true;
                }
            },
            hiddenAddDocBox: function(){//隐藏要求会诊框
                this.isShowAddDocBox = false;
            },
            inviteVideo: function(){//邀请会诊
                if(this.consultDetail.consult.consultTime){
                    this.isShowAddDocBox = true;
                }else {
                    Message({
                        showClose: true,
                        message: "未安排视频时间无法邀请",
                        type: "error"
                    });
                }
            },
            getHospList: function(showList){//获取医院列表,参数未显示下拉菜单和隐藏下拉菜单的boolean，下来为true
                if(showList){//当点击出现下拉菜单时 获取列表
                    this.loading = true;
                    let _this = this;
                    let options = {
                        Service: "smarthos.system.hos.list"
                    };
                    axiosUtil(options, function(data){
                        _this.loading = false;
                        _this.hosList = data.list;
                    });
                }
            },
            getDeptList: function(query){//获取科室列表
                if(this.acceptHosId){//如果医院已经选择完成则可以选择科室
                    this.loading = true;
                    let _this = this;
                    let options = {
                        hosId: _this.acceptHosId,
                        Service: "smarthos.system.dept.list"
                    };
                    axiosUtil(options, function(data){
                        _this.loading = false;
                        _this.deptList = data.list;
                    });
                }else{
                    Message({
                        showClose: true,
                        message: "请先选择医院",
                        type: "error"
                    });
                    return;
                }
            },
            getDeptId: function(id){//获取选择的科室ID
                let _this=this;
                _this.acceptDeptId = id;

                _this.acceptDocId = "";
                _this.getDocList();
            },
            getDocList: function(query){//获取医生列表
                let _this = this;
                if(_this.acceptHosId&&_this.acceptDeptId){//如果医院和科室已经选择完成则可以选择医生
                    _this.loading = true;
                    let options = {
                        hosId: _this.acceptHosId,
                        deptId: _this.acceptDeptId,
                        Service: "smarthos.user.doc.list"
                    };
                    axiosUtil(options, function(data){
                        _this.loading = false;
                        _this.docList = data.list;
                    });
                }else{
                    Message({
                        showClose: true,
                        message: "请先选择医院和科室",
                        type: "error"
                    });
                    return;
                }
            },
            getDocId: function(id){//获取选择的医生id
                this.acceptDocId =id;
            },
            showPerfectLisRecord: function(){// 显示历史补充资料
                let _this = this;
                _this.isShowPerfectList = !_this.isShowPerfectList;
                if(_this.isShowPerfectList == true){
                    _this.perfectList = [{perfectContent: "正在加载……"}];
                    let options = {
                        consultId: _this.consultId,
                        Service: "smarthos.consult.perfectDetail.list"
                    };
                    axiosUtil(options, function(data){
                        if (data.list.length === 0){
                            _this.perfectList = [{perfectContent: "无数据"}];
                        }else {
                            _this.perfectList = data.list;
                        }
                    });
                }

            }
        }
    }
</script>